export enum CustomerFrequencyType {
  Inactive = 1,
  Frequent,
  Infrequent
}
